"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuideListingItem = void 0;
var React = require("react");
var Dotdotdot = require("react-dotdotdot-r1");
var styles_1 = require("@/pages/guides/components/GuideListingItem/styles");
var react_measure_1 = require("react-measure");
var recompose_1 = require("recompose");
var enhance = recompose_1.compose(recompose_1.withState('width', 'setWidth', 320));
var Component = function (_a) {
    var guideItem = _a.guideItem, translate = _a.translate, width = _a.width, setWidth = _a.setWidth;
    var title = guideItem.title, url = guideItem.url, content = guideItem.content, tags = guideItem.tags, imageUrl = guideItem.imageUrl;
    var onResize = function (contentRect) { return setWidth(contentRect.bounds.width); };
    var image = function (params) { return (React.createElement(styles_1.Link, { href: url },
        React.createElement(styles_1.Image, { ref: params.measureRef, style: { height: width * 0.5625, backgroundImage: "url(" + imageUrl + ")" } }))); };
    var renderTags = function () {
        if (tags && tags.length > 0) {
            return (React.createElement(styles_1.TagsContainer, null,
                React.createElement(styles_1.Tags, null, translate.topic + ": "),
                React.createElement(styles_1.TagsHTML, null, tags)));
        }
        return null;
    };
    return (React.createElement(styles_1.Container, null,
        React.createElement("div", { style: { flex: 1 } },
            React.createElement(react_measure_1.default, { bounds: true, onResize: onResize }, image)),
        React.createElement(styles_1.InfoContainer, null,
            React.createElement(Dotdotdot, { clamp: 2 },
                React.createElement(styles_1.Link, { href: url },
                    React.createElement(styles_1.Title, null, title))),
            React.createElement(Dotdotdot, { clamp: 3 },
                React.createElement(styles_1.Content, null, content)),
            renderTags())));
};
exports.GuideListingItem = enhance(Component);
